import Router from './Router'
import {ScrollToTopOnMount} from './components/index'
import './assets/reset.css'
import './assets/style.css'

const App = () => {
  return (
    <>
      <ScrollToTopOnMount />
      <Router />
    </>
  )
}

export default App;
